import {savedEventInfo} from '../actions/EventActions';
import {authenticateOTP} from '../actions/AppActions';
import {userNotify} from "../../modules/components/Toasts/ToastAdd";
import eventCallApi from '../../util/apiEventCaller';
import {setEnquiryFormVisibleState, setHaveUsCallYouFormVisibleState, setSideBarHaveUsCallYouFilled} from './LeadFormActions';
import { getLeadFormTriggerCodeForNcr } from '../../util/leadFormUtility';
import { getCurrentPage } from '../../util/vmCookieHandler';
import { createSuperEvent } from '../../modules/utility/trackingWrapper';
import { isEmpty } from 'lodash';

export const CLOSE_USER_PHONE = 'CLOSE_USER_PHONE';
export const EDIT_USER_PHONE = 'EDIT_USER_PHONE';
export const VERIFYING_OTP = 'VERIFYING_OTP';
export const SENDING_OTP = 'SENDING_OTP';
export const UPDATE_OTP_SENT_STATE = 'UPDATE_OTP_SENT_STATE';
export const UPDATING_USER_PHONE = 'UPDATING_USER_PHONE';
export const SHOW_VERIFICATION_MODAL = 'SHOW_VERIFICATION_MODAL';
export const SHOW_HAVE_US_CALL_YOU_SUCESS_MODAL = 'SHOW_HAVE_US_CALL_YOU_SUCESS_MODAL';

export function closeUserPhoneNumber() {
    return {
        type: CLOSE_USER_PHONE,
        isUpdatingPhone: false,
        isUserPhoneNotEditable: true,
    };
}

export function editUserPhoneNumber() {
    return {
        type: EDIT_USER_PHONE,
        isUserPhoneNotEditable: false,
    };
}

export function showVerifyingOTPLoader(val) {
    return {
        type: VERIFYING_OTP,
        isVerifyingOTP: !!val,
    };
}

export function updateOTPSentState(val) {
    return {
        type: UPDATE_OTP_SENT_STATE,
        isOTPSent: !!val,
    };
}

export function setVendorHaveUsCallSuccessModalState(val) {
    return {
        type: SHOW_HAVE_US_CALL_YOU_SUCESS_MODAL,
        isShowVendorHaveUsCallYouSuccess: val
    }
}

export function verifyOTPCode(id, code, context,triggerData) {
    return (dispatch) => {
        dispatch(showVerifyingOTPLoader(true));
        return eventCallApi(`v3/dashboard/user/event/${id}/verify-otp`, 'POST', {
            code: code,
        })
            .then(res => {
                if (res && res.data && res.data.event) {
                    dispatch(savedEventInfo(res.data.event));
                    dispatch(showVerifyingOTPLoader(false));
                    let creds = {
                        phone: res.data.event.contact_phone,
                        otp: code,
                    };
                    dispatch(authenticateOTP(creds, null));
                    userNotify('Event Created', 'success');
                    if (res.data.event.isVerified) {
                        userNotify('Phone Verified', 'success');
                        if (context === "vendor-have-us-callyou") {
                            dispatch(setVendorHaveUsCallSuccessModalState(true))
                            dispatch(setEnquiryFormVisibleState(false))
                            dispatch(setSideBarHaveUsCallYouFilled(true))
                          

                        }
                        dispatch(savedEventInfo(res.data.event));
                        dispatch(showVerifyingOTPLoader(false));
                        let creds = {
                            phone: res.data.event.contact_phone,
                            otp: code,
                        };
                        dispatch(authenticateOTP(creds, null));
                        if(!isEmpty(triggerData)){
                            createSuperEvent({
                                event_name: `${triggerData?.pageSource || "ncr"}-lead-form-otp-verify` ,
                                btn_label: 'Verify-Otp',
                                action_name: 'Verify-Otp-details',
                                feature_name: 'lead-form',
                                segment_name: 'otp-slide',
                            });
                            createSuperEvent({
                                event_name: `${triggerData?.pageSource || "ncr"}-lead-form-otp-verify-${triggerData?.leadFormTriggerCode}`,
                                btn_label: 'Verify-Otp',
                                action_name: 'Verify-Otp',
                                feature_name: 'lead-form',
                                segment_name: 'otp-slide',
                            });

                            createSuperEvent({
                                event_name: `${getLeadFormTriggerCodeForNcr(triggerData?.selectedVenue,triggerData?.pageSource,getCurrentPage(),triggerData?.leadFormMode)}-lead-form-otp-verify-${triggerData?.leadFormTriggerCode}`,
                                btn_label: 'Verify-Otp',
                                action_name: 'Verify-Otp',
                                feature_name: 'lead-form',
                                segment_name: 'otp-slide',
                            });
                            createSuperEvent({
                                event_name: `${getLeadFormTriggerCodeForNcr(triggerData?.selectedVenue,triggerData?.pageSource,getCurrentPage(),triggerData?.leadFormMode)}-lead-form-otp-verify` ,
                                btn_label: 'Verify-Otp',
                                action_name: 'Verify-Otp',
                                feature_name: 'lead-form',
                                segment_name: 'otp-slide',
                            });
                            
                        }
                    } else {
                        dispatch(showVerifyingOTPLoader(false));
                        // userNotify('Verification failed, please try again later', 'error');
                    }
                } else {
                    dispatch(showVerifyingOTPLoader(false));
                    userNotify('Verification failed, please try again later', 'error');
                }
            });
    };
}

export function verifyOTPCodeForEmail(id, code, isAuthenticated) {
    return (dispatch) => {
        dispatch(showVerifyingOTPLoader(true));
        return eventCallApi(`dashboard/user/customer-event/${id}/verify-email-otp`, 'POST', {
            code: code,
        })
            .then(res => {
                if (res && res.data && res.data.event) {
                    if (res.data.event.isVerified) {
                        userNotify('Email Verified', 'success');
                        dispatch(savedEventInfo(res.data.event));
                        dispatch(showVerifyingOTPLoader(false));
                        if (!isAuthenticated) {
                            let creds = {
                                phone: res.data.event.contact_phone,
                                otp: code,
                            };
                            dispatch(authenticateOTP(creds));
                        }
                    } else {
                        dispatch(showVerifyingOTPLoader(false));
                        userNotify('Verification failed, please try again later', 'error');
                    }
                } else {
                    dispatch(showVerifyingOTPLoader(false));
                    userNotify('Verification failed, please try again later', 'error');
                }
            });
    };
}

export function setSendingOTP(val) {
    return {
        type: SENDING_OTP,
        isSendingOTP: !!val,
    };
}

export function showUpdatingPhoneLoader(val) {
    return {
        type: UPDATING_USER_PHONE,
        isUpdatingPhone: !!val,
    };
}

export function verifyEventByPhone(id, phone) {
    return (dispatch) => {
        dispatch(setSendingOTP(true));
        dispatch(updateOTPSentState(false));
        eventCallApi(`v3/dashboard/user/customer-event/${id}/send-otp-verify`, 'POST', {
            phone: phone,
        })
            .then(res => {
                if (res && res.data && res.data.event) {
                    dispatch(setSendingOTP(false));
                    dispatch(savedEventInfo(res.data.event));
                    if (res.data.event && res.data.event.isOTPSent) {
                        dispatch(updateOTPSentState(true));
                        // userNotify('OTP sent', 'success');
                    } else {
                        userNotify('Sending OTP failed, please try again later', 'error');
                    }
                } else {
                    dispatch(setSendingOTP(false));
                    userNotify('Sending OTP failed, please try again later', 'error');
                }
            });
    };
}

export function sendFirstVerificationSms(id, phone) {
    return (dispatch) => {
        dispatch(setSendingOTP(true));
        dispatch(updateOTPSentState(false));
        return eventCallApi(`v3/dashboard/user/customer-event/${id}/send-otp-verify`, 'POST', {
            phone: phone,
        }).then(res => {
            if (res.data && res.data.event) {
                dispatch(setSendingOTP(false));
                dispatch(savedEventInfo(res.data.event));
                if (res.data.event && res.data.event.isOTPSent) {
                    // dispatch(verifyOTPCode(res.data.event._id, res.data.event.otp, ""))
                    dispatch(updateOTPSentState(true));
                    // userNotify('OTP sent', 'success');
                } else {
                    userNotify('Sending OTP failed, please try again later', 'error');
                }
            } else {
                dispatch(setSendingOTP(false));
                userNotify('Sending OTP failed, please try again later', 'error');
            }
        });
    };
}


export function sendFirstVerificationEmail(id, email) {
    return (dispatch) => {
        dispatch(setSendingOTP(true));
        dispatch(updateOTPSentState(false));
        return eventCallApi(`dashboard/user/customer-event/${id}/send-email-otp-verify`, 'POST', {
            email: email,
        }).then(res => {
            if (res.data && res.data.event) {
                dispatch(setSendingOTP(false));
                dispatch(savedEventInfo(res.data.event));
                if (res.data.event && res.data.event.isOTPSent) {
                    dispatch(updateOTPSentState(true));
                    // userNotify('OTP sent', 'success');
                } else {
                    userNotify('Sending OTP failed, please try again later', 'error');
                }
            } else {
                dispatch(setSendingOTP(false));
                userNotify('Sending OTP failed, please try again later', 'error');
            }
        });
    };
}

export function updateUserPhoneNumber(id, country_code, contact_phone) {
    return (dispatch) => {
        dispatch(showUpdatingPhoneLoader(true));
        let event = {};
        event.contact_phone = contact_phone;
        event.country_code = country_code;

        return eventCallApi(`customer/dashboard/user/${id}/update-customer-phone`, 'POST', {
            event: event,
        }).then(res => {
            if (res && res.status === 'Success') {
                dispatch(savedEventInfo(res.data.event));
                dispatch(closeUserPhoneNumber());
                dispatch(sendFirstVerificationSms(id, contact_phone));
            } else {
                userNotify('Updation failed, please try again later', 'error');
            }
        });
    };
}

export function updateCustomerEvent(id, event, isUpdateEmail = false) {
    return (dispatch) => {
        dispatch(showUpdatingPhoneLoader(true));
        return eventCallApi(`customer/dashboard/user/${id}/update-customer-event`, 'POST', {
            event: event,
        }).then(res => {
            if (res && res.status === 'Success') {
                dispatch(savedEventInfo(res.data.event));
                dispatch(closeUserPhoneNumber());
                if (isUpdateEmail) {
                    dispatch(sendFirstVerificationEmail(id, event.customer_email));
                }
            } else {
                userNotify('Updation failed, please try again later', 'error');
            }
        });
    };
}

